import { default as _91event_id_93zOWaWwQIv2Meta } from "/tmp/build_58fff9e7/pages/events/[event_id].vue?macro=true";
import { default as experienceseVDUy908PaMeta } from "/tmp/build_58fff9e7/pages/experiences.vue?macro=true";
import { default as indexhTgYsFuNzJMeta } from "/tmp/build_58fff9e7/pages/index.vue?macro=true";
import { default as _91meeting_type_id_93n6pjqGVuHxMeta } from "/tmp/build_58fff9e7/pages/sessions/[meeting_type_id].vue?macro=true";
import { default as indexa9fAGvz2YEMeta } from "/tmp/build_58fff9e7/pages/sessions/index.vue?macro=true";
import { default as events_45slider_45exampleGOE6wg8kBqMeta } from "/tmp/build_58fff9e7/pages/widgets/events-slider-example.vue?macro=true";
import { default as events_45slidergQznKwHjbCMeta } from "/tmp/build_58fff9e7/pages/widgets/events-slider.vue?macro=true";
export default [
  {
    name: "events-event_id",
    path: "/events/:event_id()",
    component: () => import("/tmp/build_58fff9e7/pages/events/[event_id].vue")
  },
  {
    name: "experiences",
    path: "/experiences",
    meta: experienceseVDUy908PaMeta || {},
    component: () => import("/tmp/build_58fff9e7/pages/experiences.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/build_58fff9e7/pages/index.vue")
  },
  {
    name: "sessions-meeting_type_id",
    path: "/sessions/:meeting_type_id()",
    component: () => import("/tmp/build_58fff9e7/pages/sessions/[meeting_type_id].vue")
  },
  {
    name: "sessions",
    path: "/sessions",
    meta: indexa9fAGvz2YEMeta || {},
    component: () => import("/tmp/build_58fff9e7/pages/sessions/index.vue")
  },
  {
    name: "widgets-events-slider-example",
    path: "/widgets/events-slider-example",
    meta: events_45slider_45exampleGOE6wg8kBqMeta || {},
    component: () => import("/tmp/build_58fff9e7/pages/widgets/events-slider-example.vue")
  },
  {
    name: "widget-events-slider",
    path: "/widgets/events-slider",
    meta: events_45slidergQznKwHjbCMeta || {},
    component: () => import("/tmp/build_58fff9e7/pages/widgets/events-slider.vue")
  }
]